import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';

const PlaceholderCard = ({ title, message }) => (
  <Card>
    <CardContent>
      <Typography variant="h5" sx={{ mb: 1 }}>{title}</Typography>
      <Typography variant="body2" sx={{ opacity: 0.8 }}>
        {message}
      </Typography>
    </CardContent>
  </Card>
);

export default PlaceholderCard;
